import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["setValue", "groupId", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { usePreviousProp, useToggle } from '@infl-ts/util-hooks';
import { useHubApi } from '@infl-ts/util-use-hub-api';
import { Autocomplete, Paper } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { flow, identity } from 'fp-ts/function';
import { useEffect, useState } from 'react';
import AvatarTextField from './avatar-textfield';
import { Members } from './codecs';
import convertTermToAql from './convert-term-to-aql';
import Option from './option';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export var PureProfileAutocomplete = function PureProfileAutocomplete(_ref) {
  var disabled = _ref.disabled,
      value = _ref.value,
      setValue = _ref.setValue,
      hasCorporateAccess = _ref.hasCorporateAccess,
      open = _ref.open,
      setOpen = _ref.setOpen,
      setClosed = _ref.setClosed,
      inputValue = _ref.inputValue,
      setInputValue = _ref.setInputValue,
      members = _ref.members,
      loading = _ref.loading,
      placeholder = _ref.placeholder;
  return /*#__PURE__*/_jsx(Autocomplete, {
    open: open,
    onOpen: setOpen,
    onClose: setClosed,
    value: value,
    disabled: disabled,
    loading: loading,
    onChange: function onChange(_event, newValue) {
      return setValue(newValue);
    },
    inputValue: inputValue,
    onInputChange: function onInputChange(_event, newInputValue) {
      return setInputValue(newInputValue || '');
    },
    options: members,
    noOptionsText: "No advocates match your search",
    getOptionLabel: function getOptionLabel(member) {
      return member.name;
    },
    isOptionEqualToValue: function isOptionEqualToValue(option, value) {
      return option.uuid === value.uuid;
    },
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/_createElement("li", _objectSpread(_objectSpread({}, props), {}, {
        key: option.uuid
      }), /*#__PURE__*/_jsx(Option, {
        member: option,
        hasCorporateAccess: hasCorporateAccess
      }));
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_jsx(AvatarTextField, {
        params: params,
        member: value,
        loading: loading,
        open: open,
        placeholder: placeholder
      });
    },
    PaperComponent: function PaperComponent(props) {
      return /*#__PURE__*/_jsx(Paper, _objectSpread(_objectSpread({}, props), {}, {
        style: {
          minWidth: 300
        }
      }));
    },
    disablePortal: true,
    filterOptions: identity,
    size: "small",
    "data-element": "Autocomplete",
    "data-component": "PureProfileAutocomplete",
    "data-source-file": "index.tsx"
  });
};

var useProps = function useProps(_ref2) {
  var setValue = _ref2.setValue,
      groupId = _ref2.groupId,
      placeholder = _ref2.placeholder,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setOpen = _useToggle2$.on,
      setClosed = _useToggle2$.off;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var oldGroupId = usePreviousProp(groupId);
  var members = useHubApi({
    url: '/advocate_search',
    method: 'get',
    outputCodec: Members,
    params: {
      aql: JSON.stringify(convertTermToAql(inputValue, groupId !== null && groupId !== void 0 ? groupId : ''))
    },
    dependencyList: [inputValue, groupId]
  });
  useEffect(function () {
    var isMounted = true;

    if (groupId && groupId !== '0' && groupId !== oldGroupId && isMounted) {
      setOpen();
      setValue(null);
    }

    return function () {
      isMounted = false;
    };
  }, [groupId, oldGroupId, setOpen, setValue]);
  return _objectSpread(_objectSpread({}, props), {}, {
    placeholder: placeholder,
    open: isOpen,
    setOpen: setOpen,
    setClosed: setClosed,
    setValue: setValue,
    inputValue: inputValue,
    setInputValue: setInputValue,
    loading: DE.isPending(members) || DE.isRefresh(members),
    members: DE.isSuccess(members) ? members.value.right : []
  });
};

export default Object.assign(flow(useProps, PureProfileAutocomplete), {
  displayName: 'ProfileAutocomplete'
});